Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $(".x-coupon-validator-form");
    if ($wrapper.length == 0) return;

    var wrapper = $wrapper.get(0);

    var currentCouponCode = "";
    var loading = false;

    var $couponValidatorForm = $('.js-coupon-validator-form', $wrapper);
    var couponValidatorForm = $couponValidatorForm.length > 0 ? $couponValidatorForm.get(0) : null;
    var $couponInfoForm = $('.coupon-info-form', $wrapper);
    var couponInfoForm = $couponInfoForm.length > 0 ? $couponInfoForm.get(0) : null;

    var fancyOpts = {
        padding: 0,
        margin: [50, 0, 0, 0],
        maxWidth: 750,
        height: 'auto',
        topRatio: 0,
        closeBtn: false,
        fitToView: true,
        autoSize: false,
        helpers: {
            overlay: {
                closeClick: false
            }
        }
    };

    $wrapper.on('click', '.js-password-reveal', function (e) {
        e.preventDefault();
        if ($(this).hasClass('shown')) {
            $(this).removeClass('shown').siblings('input').prop('type', 'password');
        } else {
            $(this).addClass('shown').siblings('input').prop('type', 'text');
        }
    });

    wrapper.validateSuccess = function (xhr) {
        $('.error-wrapper', $couponValidatorForm).children().toggleClass('js-visible', false);
        $('.success-wrapper', $couponInfoForm).toggleClass('js-visible', false);
        var res = xhr.message.data.model;
        if (res.success) {
            var data = res.data;
            var isCodeVisible = $(".js-password-reveal", $wrapper).hasClass('shown');
            $("[name='CouponCode']", $wrapper).val("");
            $(".js-validate-code", $wrapper).prop("disabled", true).toggleClass("disabled", true);
            $(".js-confirm-delete-btn", $wrapper).prop("disabled", data.IsInvalidated).toggleClass("disabled", data.IsInvalidated);

            data.Code = isCodeVisible ? data.Code : data.Code.replace(/./g, '*');
            var html = Vendd.Handlebars.parse("accountCouponValidatorBox_A", data);
            $(".x-coupon-box", $couponInfoForm).html(html);
            //$("[data-id='Name']").text(data.Name);
            //$("[data-id='Description']").text(data.Description);
            //$("[data-id='Amount']").text(data.Amount);
            //$("[data-id='Code']").text(isCodeVisible ? data.Code : data.Code.replace(/./g, '*'));

            $('.x-coupon-box', $couponInfoForm).toggleClass('hidden', false);
            $couponInfoForm.toggleClass("hidden", false);
            $couponValidatorForm.toggleClass("hidden", true);
            currentCouponCode = data.Code || "";
        } else {
            $('.validation-invalid-error', $couponValidatorForm).toggleClass('js-visible', true);
        }
        loading = false;
    }
    wrapper.validateFail = function (res) {
        $('.validation-generic-error', $couponValidatorForm).toggleClass('js-visible', true);
        loading = false;
    }
    $wrapper.on('change keyup', "[name='CouponCode']", function (e) {
        if (e.keyCode && e.keyCode == 13) return;
        $('.error-wrapper', $couponValidatorForm).children().toggleClass('js-visible', false);
        var isValid = ($(this).val().trim() || "") != "";
        $(".js-validate-code", $wrapper).prop("disabled", !isValid).toggleClass("disabled", !isValid);
    });

    $couponValidatorForm.on('submit', function (e) {
        e.preventDefault();
        if ($(".js-validate-code", $couponValidatorForm).is(".disabled") || loading) return;
        loading = true;
        var code = $("[name='CouponCode']", $wrapper).val();
        Vendd.MessageBus.publishAsync(couponInfoForm, new Vendd.Account.Messages.GetCouponInformations({
            couponCode: code
        }));
    });

    if ($couponInfoForm.length > 0) {

        $wrapper.on('click', '.js-back-button', function (e) {
            e.preventDefault();
            $("[data-id='Name']").text("");
            $("[data-id='Description']").text("");
            $("[data-id='Amount']").text("");
            $("[data-id='Code']").text("");
            $couponInfoForm.toggleClass("hidden", true);
            $couponValidatorForm.toggleClass("hidden", false);
            currentCouponCode = "";
        });

        couponInfoForm.onSuccess = function () {
            $(".js-confirm-delete-btn", $wrapper).prop("disabled", true).toggleClass("disabled", true);
            $('.js-content', $couponInfoForm).hide();
            $('.error-wrapper', $couponInfoForm).children().toggleClass('js-visible', false);
            $('.success-wrapper', $couponInfoForm).toggleClass('js-visible', true);
            $('.x-coupon-box', $couponInfoForm).toggleClass('hidden', true);
            currentCouponCode = "";
        };

        couponInfoForm.onFailure = function () {
            $('.error-wrapper', $couponInfoForm).children().toggleClass('js-visible', true);
            $('.success-wrapper', $couponInfoForm).toggleClass('js-visible', false);
        };

        $('.js-delete-btn', $couponInfoForm).click(function () {
            if (currentCouponCode != "") {
                Vendd.MessageBus.publishAsync(couponInfoForm, new Vendd.Account.Messages.InvalidateCouponCode({
                    couponCode: currentCouponCode
                }));
            }
        });

        $('.js-confirm-delete-btn', $couponInfoForm).click(function () {
            if ($(".js-confirm-delete-btn", $couponInfoForm).is(".disabled") || loading) return;
            $(".open-fancy-confirm", $couponInfoForm).trigger("click");
        });

        $(".open-fancy-confirm", $couponInfoForm).fancybox(fancyOpts);

        $('.x-confirmation-popup.delete .popup-btn').click(function () {
            $.fancybox.close();
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCouponInformationsSuccess, couponInfoForm, wrapper.validateSuccess);
        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCouponInformationsFailed, couponInfoForm, wrapper.validateFail);

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.InvalidateCouponCodeSuccess, couponInfoForm, couponInfoForm.onSuccess);
        Vendd.MessageBus.subscribe(Vendd.Account.Messages.InvalidateCouponCodeFailed, couponInfoForm, couponInfoForm.onFailure);
    }
});